import { CartType } from '@src/routes'

export default function isMarketplaceType(
  cartType: CartType | null | undefined | string | string[]
): boolean {
  return (
    cartType === CartType.MarketplaceCart ||
    cartType === CartType.MarketplaceBuyNowCart
  )
}
